import React from 'react';
import PropTypes from 'prop-types';

// TRANSLATIONS
import { useTranslation } from 'react-i18next';

// ICONS
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

// HOOKS
import useDeleteEntity from '../../../Hooks/useDeleteEntity';

// COMPONENTS
import DeleteConfirmModal from '../Delete/DeleteConfirmModal';
import DeleteEntityQuestion from '../Delete/DeleteEntityQuestion';

// STYLES
import style from '../../../../scss/components/buttons/button.module.scss';

const FormDelete = ({ entity, service, resource }) => {
    const { t } = useTranslation();
    const {
        markedForDeletion,
        markForDeletion,
        clearMarkedForDeletion,
        confirmDelete,
        error,
        isDeleting,
    } = useDeleteEntity({
        service,
        resource,
        onSuccess: () => window.history.back(),
    });

    return (
        <>
            <button
                className={style.delete}
                type="button"
                onClick={() => markForDeletion(entity)}
            >
                <span className={style.formDeleteText}>
                    {t('application.delete')}
                </span>
                <FontAwesomeIcon className={style.rejectIcon} icon={faTrash} />
            </button>
            <DeleteConfirmModal
                isOpen={!!markedForDeletion}
                onRequestClose={clearMarkedForDeletion}
                onConfirm={confirmDelete}
                error={error}
                isDeleting={isDeleting}
            >
                {markedForDeletion && (
                    <DeleteEntityQuestion entity={markedForDeletion} />
                )}
            </DeleteConfirmModal>
        </>
    );
};

export default FormDelete;

FormDelete.propTypes = {
    service: PropTypes.object.isRequired,
    entity: PropTypes.object.isRequired,
    resource: PropTypes.string.isRequired,
};
